export const SEARCH_ERROR = 'Unable to load search results';
